var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./pages/ipaper").init());
    processInclude(require("./pages/sitemap").init());
    processInclude(require("./pages/help").init());
});
